module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-confirm/dialog-confirm.component.css
// module id = ./src/app/dialog-confirm/dialog-confirm.component.css
// module chunks = main